import styled from 'styled-components';

export const DeclaracaoSubtitle = styled.p `
    font-weight: bold;
    padding-top: 22px;

    > span > span {
        font-weight: normal;
    }
`;
